import type { ConductorStageContent, StageDialogFormValues } from '../types';

/**
 * Whether a stage is configured: it needs both a goal and instructions, and a whitespace-only
 * field counts as missing. The conductor-config payload applies the same rule to the row it
 * serves, so for a scope served from its own row a stage shown as "Not configured" here is one
 * the conductor is not given. A sub-organization scope with no row of its own is served the
 * organization-level row instead, which this screen does not show.
 */
const isStageConfigured = (content: Partial<StageDialogFormValues> | ConductorStageContent | undefined): boolean =>
  Boolean(content?.goal?.trim() && content?.instructions?.trim());

export default isStageConfigured;
